import {
  ADD_OPTION,
  REMOVE_OPTION,
  REMOVE_ALL,
  SORTS_RECEIVED,
  TAGS_RECEIVED,
  SHOW_TAG,
  HIDE_TAG,
  SHOW_ALL,
  UPDATE_SORT,
  TOGGLE_TAGS_ENABLED,
} from './constants';

/**
 *
 * @param sort
 * @returns {{filters: *, type: string}}
 */
export const sortsLoaded = sorts => ({
  type: SORTS_RECEIVED,
  sorts,
});
/**
 *
 * @param tags
 * @returns {{filters: *, type: string}}
 */
export const tagsLoaded = tags => ({
  type: TAGS_RECEIVED,
  tags,
});

/**
 *
 * @returns {{type: string}}
 */
export const removeAllOptions = () => ({
  type: REMOVE_ALL,
});

/**
 * @param value
 * @param label
 * @returns {{label: *, type: string, value: *}}
 */
export function addOption(value, label) {
  return {
    type: ADD_OPTION,
    label,
    value,
  };
}

/**
 *
 * @param value
 * @returns {{type: string, value: *}}
 */
export function removeOption(value) {
  return {
    type: REMOVE_OPTION,
    value,
  };
}

/**
 *
 * @param value
 * @returns {{type: string, value: *}}
 */
export function showTag(value) {
  return {
    type: SHOW_TAG,
    value,
  };
}

/**
 *
 * @param value
 * @returns {{type: string, value: *}}
 */
export function hideTag(value) {
  return {
    type: HIDE_TAG,
    value,
  };
}

/**
 *
 * @returns {{type: string}}
 */
export const showAllTags = () => ({
  type: SHOW_ALL,
});

/**
 *
 * @param sort
 * @returns {{type: string, sort: string}}
 */
export function orderBy(sort) {
  return {
    type: UPDATE_SORT,
    sort,
  };
}

export function enableTags() {
  return {
    type: TOGGLE_TAGS_ENABLED,
    isEnabled: true
  };
}

export function disableTags() {
  return {
    type: TOGGLE_TAGS_ENABLED,
    isEnabled: false
  };
}
